import { MembershipRole } from '@/lib/types';

// The ten documented scopes, mirrored from the backend's APIKeyScope (#6234).
export const API_KEY_SCOPES: { value: string; label: string; description: string }[] = [
  { value: 'organizations:read', label: 'Organizations: read', description: 'Your organizations, account overview, business profile' },
  { value: 'campaigns:read', label: 'Campaigns: read', description: 'Campaigns, keywords, detector runs' },
  { value: 'campaigns:write', label: 'Campaigns: write', description: 'Budgets, names, target CPA, state, new campaigns and ads' },
  { value: 'keywords:write', label: 'Keywords: write', description: 'Add negative keywords' },
  { value: 'performance:read', label: 'Performance: read', description: 'Metrics and search terms' },
  { value: 'recommendations:read', label: 'Recommendations: read', description: 'List recommendations' },
  { value: 'recommendations:apply', label: 'Recommendations: apply', description: 'Apply recommendations and undo changes' },
  { value: 'reports:read', label: 'Reports: read', description: 'Retrieve generated reports and Strategic Plans' },
  { value: 'reports:generate', label: 'Reports: generate', description: 'Trigger report generation, and writing a Strategic Plan' },
  { value: 'audit:read', label: 'Audit: read', description: 'Action log and audit trail export (Owner keys only)' },
];

// Role ceilings, mirrored from the backend's ROLE_SCOPE_CEILINGS: the picker never
// offers a scope the server would refuse.
const MEMBER_SCOPES = [
  'organizations:read',
  'campaigns:read',
  'performance:read',
  'recommendations:read',
  'reports:read',
  'reports:generate',
];
const ADMIN_SCOPES = [...MEMBER_SCOPES, 'campaigns:write', 'keywords:write', 'recommendations:apply'];
const OWNER_SCOPES = [...ADMIN_SCOPES, 'audit:read'];

export const SCOPES_BY_ROLE: Record<MembershipRole, string[]> = {
  [MembershipRole.MEMBER]: MEMBER_SCOPES,
  [MembershipRole.ADMIN]: ADMIN_SCOPES,
  [MembershipRole.OWNER]: OWNER_SCOPES,
};
